import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorNotification(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="18"
      height="20"
      ariaLabel="Notification Icon"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        fill={`url(#${id})`}
        d="M8.11572 0.554583V1.27624C5.08737 1.7012 2.74771 4.32032 2.74771 7.4759V9.97066C2.74771 11.7401 1.97519 13.413 0.622226 14.5619C0.275634 14.8595 0.0751953 15.2956 0.0751953 15.7526C0.0751953 16.6164 0.772555 17.3166 1.63277 17.3166H5.70878C6.01931 18.8454 7.36946 20 8.98225 20C10.595 20 11.9452 18.8454 12.2557 17.3166H16.3316C17.1918 17.3166 17.8934 16.6164 17.8892 15.7484C17.8892 15.2914 17.6888 14.8595 17.3338 14.5535C15.9892 13.413 15.2167 11.7401 15.2167 9.97066V7.4759C15.2167 4.32026 12.8769 1.7011 9.84851 1.27622V0.554583C9.84851 0.250106 9.45863 0 8.98212 0C8.5056 0 8.11572 0.250106 8.11572 0.554583Z"
      />
      <defs>
        <linearGradient
          id={id}
          x1="17.8892"
          y1="11.6071"
          x2="0.075213"
          y2="11.6246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B6AFF" />
          <stop offset="1" stopColor="#39D0D8" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
